import classNames from 'classnames';

import styles from './accent-progress.module.scss';

export interface Props {
  className?: string;
  progress?: number;
}

const AccentProgress = ({ className, progress = 0 }: Props) => (
  <progress
    className={classNames(styles.container, className)}
    value={progress}
  />
);

export default AccentProgress;
